const CARDS = [
  {
    title: '都市恋爱法则',
    tag: '韩漫·恋爱',
    desc: '高冷总裁与职场新人的甜蜜拉扯，每周更新，千万读者在线追更中。',
    heat: '9.6',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20manga%20style%20illustration%20of%20a%20romantic%20couple%20in%20a%20city%20setting%2C%20warm%20peach%20and%20cream%20color%20palette%2C%20soft%20ambient%20lighting%2C%20delicate%20character%20art%2C%20gentle%20pastel%20background%2C%20clean%20lines%2C%20stylized%20anime%20aesthetic%2C%20harmonious%20composition%2C%20cozy%20atmosphere&width=600&height=800&seq=card-manga-01&orientation=portrait',
  },
  {
    title: '剑道至尊',
    tag: '国漫·玄幻',
    desc: '少年持剑走天涯，热血江湖恩怨情仇，全网点击破亿人气连载。',
    heat: '9.4',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20manga%20style%20illustration%20of%20a%20young%20swordsman%20in%20flowing%20robes%2C%20warm%20golden%20and%20cream%20tones%2C%20soft%20dramatic%20lighting%2C%20detailed%20character%20art%20with%20flowing%20hair%2C%20gentle%20misty%20mountain%20background%2C%20clean%20stylized%20lines%2C%20harmonious%20composition&width=600&height=800&seq=card-manga-02&orientation=portrait',
  },
  {
    title: '异世界食堂',
    tag: '日漫·美食',
    desc: '穿越异世界开餐厅，用美食治愈每个灵魂，温馨治愈系高分作品。',
    heat: '9.7',
    image: 'https://readdy.ai/api/search-image?query=A%20charming%20manga%20style%20illustration%20of%20a%20cozy%20restaurant%20interior%20with%20warm%20lighting%2C%20delicious%20food%20on%20a%20wooden%20table%2C%20soft%20cream%20and%20peach%20color%20palette%2C%20gentle%20ambient%20glow%2C%20delicate%20anime%20art%20style%2C%20clean%20composition%2C%20inviting%20atmosphere&width=600&height=800&seq=card-manga-03&orientation=portrait',
  },
  {
    title: '暗夜追踪者',
    tag: '韩漫·悬疑',
    desc: '连环案件背后的惊天秘密，烧脑剧情层层反转，悬疑迷必追神作。',
    heat: '9.5',
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20manga%20style%20illustration%20with%20a%20noir%20atmosphere%2C%20shadowy%20cityscape%20at%20night%2C%20warm%20amber%20streetlight%20glow%2C%20cream%20and%20deep%20brown%20tones%2C%20soft%20moody%20lighting%2C%20stylized%20anime%20art%2C%20clean%20lines%2C%20suspenseful%20yet%20elegant%20composition&width=600&height=800&seq=card-manga-04&orientation=portrait',
  },
  {
    title: '凤倾天下',
    tag: '国漫·古风',
    desc: '女将军涅槃重生，权谋与情仇交织，画风华美古风迷不容错过。',
    heat: '9.3',
    image: 'https://readdy.ai/api/search-image?query=A%20gorgeous%20manga%20style%20illustration%20of%20a%20female%20warrior%20in%20elegant%20ancient%20Chinese%20robes%2C%20flowing%20silk%20and%20petals%2C%20warm%20peach%20and%20cream%20tones%2C%20soft%20golden%20lighting%2C%20delicate%20detailed%20art%2C%20clean%20stylized%20lines%2C%20harmonious%20graceful%20composition&width=600&height=800&seq=card-manga-05&orientation=portrait',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热门推荐
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            精选全网最受欢迎的漫画作品，每日更新热门推荐，总有一部让你爱不释手
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
          {CARDS.map((card, i) => (
            <a
              key={i}
              href="#carousel"
              className="group block bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-300 transition-all duration-300 overflow-hidden cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden bg-background-100">
                <img
                  src={card.image}
                  alt={`香香漫画 - ${card.title}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2 px-2 py-1 bg-accent-500/90 text-background-50 text-xs font-semibold rounded-md">
                  {card.heat}
                </div>
              </div>
              <div className="p-3 md:p-4">
                <span className="text-xs text-primary-600 font-medium">{card.tag}</span>
                <h3 className="mt-1.5 text-sm md:text-base font-semibold text-foreground-900 font-heading group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}